import * as ActionTypes from './index';

export function updateBrokerPassword(payload) {
    return {
        type: ActionTypes.UPDATE_BROKER_PASSWORD,
        payload: payload
    }
}

export function updateBrokerPasswordSuccess(payload) {
    return {
        type: ActionTypes.UPDATE_BROKER_PASSWORD_SUCCESS,
        payload: payload
    }
}

export function updateBrokerPasswordFailed(payload) {
    return {
        type: ActionTypes.UPDATE_BROKER_PASSWORD_FAILED,
        payload: payload
    }
}

export function changeBrokerPassword(payload) {
    return {
        type: ActionTypes.CHANGE_BROKER_PASSWORD,
        payload: payload
    }
}

export function openBrokerPasswordModal(payload) {
    return {
        type: ActionTypes.OPEN_BROKER_PASSWORD_MODAL,
        payload: payload
    }
}

export function closeBrokerPasswordModal(payload) {
    return {
        type: ActionTypes.CLOSE_BROKER_PASSWORD_MODAL,
        payload: payload
    }
}

export function updateBrokerById(payload) {
    return {
        type: ActionTypes.UPDATE_BROKER_BY_ID,
        payload: payload
    }
}

export function updateBrokerByIdSuccess(payload) {
    return {
        type: ActionTypes.UPDATE_BROKER_BY_ID_SUCCESS,
        payload: payload
    }
}

export function updateBrokerByIdFailed(payload) {
    return {
        type: ActionTypes.UPDATE_BROKER_BY_ID_FAILED,
        payload: payload
    }
}

export function getBrokerById(payload) {
    return {
        type: ActionTypes.GET_BROKER_BY_ID,
        payload: payload
    }
}

export function getBrokerByIdSuccess(payload) {
    return {
        type: ActionTypes.GET_BROKER_BY_ID_SUCCESS,
        payload: payload
    }
}

export function getBrokerByIdFailed(payload) {
    return {
        type: ActionTypes.GET_BROKER_BY_ID_FAILED,
        payload: payload
    }
}

export function changeBrokerState(payload) {
    return {
        type: ActionTypes.CHANGE_BROKER_STATE,
        payload: payload
    }
}

export function createBroker(payload) {
    return {
        type: ActionTypes.CREATE_BROKER,
        payload: payload
    }
}

export function createBrokerSuccess(payload) {
    return {
        type: ActionTypes.CREATE_BROKER_SUCCESS,
        payload: payload
    }
}

export function createBrokerFailed(payload) {
    return {
        type: ActionTypes.CREATE_BROKER_FAILED,
        payload: payload
    }
}

export function changeBroker(payload) {
    return {
        type: ActionTypes.CHANGE_BROKER,
        payload: payload
    }
}

export function unlockBroker(payload) {
    return {
        type: ActionTypes.UNLOCK_BROKER,
        payload: payload
    }
}

export function unlockBrokerSuccess(payload) {
    return {
        type: ActionTypes.UNLOCK_BROKER_SUCCESS,
        payload: payload
    }
}

export function unlockBrokerFailed(payload) {
    return {
        type: ActionTypes.UNLOCK_BROKER_FAILED,
        payload: payload
    }
}